const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


/* Make collection list category cards fully clickable */
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('[id*="collection_list"]');
    if (!section) return;
      var items = section.querySelectorAll('.collection-list__item');
        items.forEach(function(item) {
            var link = item.querySelector('.card--media > .card__content .card__heading a');
                if (!link) return;
                    var wrapper = item.querySelector('.card-wrapper');
                        if (!wrapper) return;
                            wrapper.addEventListener('click', function(e) {
                                  if (e.target.closest('a')) return;
                                        link.click();
                                            });
                                              });
                                              });